<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-panel-body>
                <store-form v-if="status !== 'loading'" :submit="updateStore" :query="store"></store-form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { storeService } from '@/common/api.service'
import storeForm from './components/form'
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'

export default {
    components: {
        storeForm,
        mainContent
    },
    computed: {
        ...mapGetters('store', [
            'store', 'status'
        ])
    },
    data() {
        return {
            'hashid': this.$route.params.hashid
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('store/find', vm.hashid)
        })
    },
    methods: {
        updateStore(e, query) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                rules: {
                    logo: {
                        required: false,
                    },
                    en_name: {
                        required: true,
                    },
                    fa_name: {
                        required: true,
                    },
                    callback_url: {
                        url: true,
                    },
                    description: {
                        required: true,
                    },
                    gateway_id: {
                        required: true
                    }
                },
            });


            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)
            storeService.update(this.hashid, query)
            .then(response => {
                this.$router.push('/stores')
                this.showMsg(form, 'success', response.data.message)
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTUtil.scrollTop()
                KTApp.unprogress(btn)
            })
        }
    }
}
</script>